exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn.mobile {\n  background-color: #2baf78;\n  color: #fff;\n  border-radius: 24px; }\n  .btn.mobile:not(:hover):not(:active:focus) {\n    background-color: #2baf78; }\n", ""]);

